import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ageing-report',
  templateUrl: './ageing-report.component.html',
  styleUrls: ['./ageing-report.component.scss']
})
export class AgeingReportComponent implements OnInit {

  constructor(private reportService:ReportService) { }

  ngOnInit(): void {
  }
  generateExcel  () {
    // Swal.fire({
    //     position: 'center',
    //     icon: 'info',
    //     text:'Please wait while the document is being prepared for reading.',
    //     showConfirmButton: true,
    //     timer:5000
    // })
    this.reportService.getAgeingReport().subscribe((result)=> {
        if (result) {
            const linkSource = 'data:application/vnd.openxmlformats - officedocument.spreadsheetml.sheet;base64, ' + result;
            const downloadLink = document.createElement('a');
            const fileName = 'Home-Connect Aging Report.xls';
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
    });

}
}
